module.exports = __webpack_public_path__ + "static/cover-d830bf19f55d76003bad23b5f36ee54e.png";